import React from "react";
import realTimeProtectionImage from "./image/features/real-time-protection.png";
import ransomwareProtectionImage from "./image/features/ransomware-protection.png";
import usbProtectionImage from "./image/features/usb-protection.png";
import webcamProtectionImage from "./image/features/webcam-protection.png";
import gameBoosterImage from "./image/features/game-booster.png";
import phishingProtectionImage from "./image/features/phishing-protection.png";
import tempFilesCleanerImage from "./image/features/temp-files-cleaner.png";
import websiteBlockerImage from "./image/features/website-blocker.png";
import privacyWifiScannerImage from "./image/features/privacy-wifi-scanner.png";
import dataEncryptionImage from "./image/features/data-encryption.png";
import dataRecoveryBackupImage from "./image/features/data-recovery-backup.png";
import registryCleanerOptimizerImage from "./image/features/registry-cleaner-optimizer.png";

const featureImages = {
    "Real Time Protection": realTimeProtectionImage,
    "Ransomware Protection": ransomwareProtectionImage,
    "USB Protection": usbProtectionImage,
    "Webcam Protection": webcamProtectionImage,
    "Game Booster": gameBoosterImage,
    "Phishing and Malicious Website Protection": phishingProtectionImage,
    "Temp Files Cleaner": tempFilesCleanerImage,
    "Website Blocker": websiteBlockerImage,
    "Privacy Cleaner and Wi-Fi Scanner": privacyWifiScannerImage,
    "Data Encryption": dataEncryptionImage,
    "Data Recovery and Backup Manager": dataRecoveryBackupImage,
    "Registry Cleaner and Registry Optimizer": registryCleanerOptimizerImage,
};

function ProductFeatureSection({ feature, index }) {
    const imageFirst = index % 2 === 0;
    const image = featureImages[feature.title] || feature.image;
    const cardClass = "group rounded-2xl border border-[#E5E9EE] bg-white p-5 shadow-sm transition duration-200 hover:-translate-y-1 hover:border-[#FA7223]/50 hover:shadow-lg sm:p-6";

    return (
        <article className="relative grid items-start gap-4 pl-0 lg:grid-cols-[minmax(0,1fr)_64px_minmax(0,1fr)] lg:gap-0 lg:pl-0">
            <span className="absolute left-1/2 top-1/2 z-10 hidden h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-4 border-white bg-[#FA7223] shadow-[0_0_0_3px_rgba(250,114,35,0.15)] lg:block" />
            <div className={imageFirst ? "lg:col-start-1" : "lg:col-start-3"}>
                <div className={cardClass + " flex flex-col items-start gap-4 lg:flex-row lg:items-center " + (imageFirst ? "lg:flex-row-reverse" : "") }>
                    <div className="flex h-24 w-24 shrink-0 self-center lg:self-auto items-center justify-center sm:h-28 sm:w-28"><img src={image} alt={feature.title + " in " + feature.productName} width="1254" height="1254" loading="lazy" className="h-full w-full object-contain transition duration-200 group-hover:scale-105" /></div>
                    <div className="min-w-0"><h3 className="text-xl font-semibold text-[#243342]">{feature.title}</h3><p className="mt-2 text-sm leading-6 text-[#64707D]">{feature.description}</p><ul className="mt-3 space-y-1.5">{feature.benefits.map((benefit) => <li key={benefit} className="flex gap-2 text-sm leading-5 text-[#64707D]"><span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#FA7223] text-[10px] font-bold text-white">✓</span><span>{benefit}</span></li>)}</ul></div>
                </div>
            </div>
            <div className="relative hidden h-full self-stretch lg:col-start-2 lg:block" />
        </article>
    );
}

export default ProductFeatureSection;
